import SITE_CONSTANTS from '../siteConstants'

const names = {
  arrowDown: 'arrowDown.svg',
  arrows: 'arrows.svg',
  avatar: 'avatar.svg',
  activeAvatar: 'activeAvatar.svg',
  businessTaxi: 'business-taxi.svg',
  carAlt: 'car-alt.svg',
  cash: 'cash.svg',
  checkMark: 'check-mark.svg',
  economTaxi: 'econom-taxi.svg',
  flagRu: 'flag-ru.svg',
  flagGb: 'flag-gb.svg',
  flagFr: 'flag-fr.svg',
  flagMar: 'flag-ma.svg',
  activeMarker: 'mark-colored.svg',
  inactiveMarker: 'mark-uncolored.svg',
  menuIcon: 'menu-icon.svg',
  messageIcon: 'message-icon.svg',
  multipleUsers: 'multiple-users.svg',
  notoTaxi: 'noto-taxi.svg',
  plusIcon: 'plus-icon.svg',
  clock: 'clock.svg',
  driverAvatar: 'driver-avatar.svg',
  solidCar: 'fa-solid_car.svg',
  subwayIdCard: 'subway-id-card.svg',
  card: 'card.svg',
  stars: 'stars.svg',
  starEmpty: 'star-empty.svg',
  starFull: 'star-full.svg',
  cardIcon: 'card-icon.svg',
  photoCamera: 'photo-camera.svg',
  helpIcon: 'help-icon.svg',
  timer: 'timer.svg',
  closeIcon: 'close-icon.svg',
  cardIconGrey: 'card-icon-grey.svg',
  chatIcon: 'chat-icon.svg',
  minusCircle: 'minus-circle.svg',
  minusIcon: 'minus-icon.svg',
  plusCircle: 'plus-circle.svg',
  people: 'people.svg',
  recomended: 'recomended.svg',
  requested: 'requested.svg',
  turn: 'turn.svg',
  uGroup: 'u-group.svg',
  clockGrey: 'grey-clock.svg',
  clockGreen: 'clock-green.svg',
  turnBr: 'turn-br.svg',
  cardIconBr: 'card-icon-br.svg',
  chatIconBr: 'chat-icon-br.svg',
  mapIcon: 'map-icon.svg',
  mapArrow: 'map-arrow.svg',
  mapArrowVoting: 'map-arrow-voting.svg',
  mapOrderVoting: 'map-voting.svg',
  mapOrderWating: 'map-waiting.svg',
  mapOrderPerforming: 'map-performing.svg',
  mapMarkerProfit: 'map-marker-profit.svg',
  mapArrowHome: 'map-arrow-home.svg',
  returnIcon: 'return-icon.svg',
  passengerAvatar: 'passenger-avatar.svg',
  clockBlue: 'clock-blue.svg',
  markerGreen: 'marker-green.svg',
  markerYellow: 'marker-yellow.svg',
  loading: 'loading.gif',
  markerFrom: 'marker-from.svg',
  markerTo: 'marker-to.svg',
  voting: 'voting.svg',
  votingRed: 'voting-red.svg',
  waiting: 'waiting.svg',
  delivery: 'delivery.svg',
  light: 'light.svg',
  truck: 'truck.svg',
  wagon: 'wagon.svg',
  foot: 'foot.svg',
  bicycle: 'bicycle.svg',
  motorcycle: 'motorcycle.svg',
  motorcycleRed: 'motorcycle-red.svg',
  deliveryRed: 'delivery-red.svg',
  phone: 'phone.svg',
  bigSize: 'big-size.svg',
  boxing: 'boxing.svg',
  openedEye: 'opened-eye.svg',
  closedEye: 'closed-eye.svg',
  error: 'error.svg',
  fetching: 'fetching.svg',
  move: 'move.svg',
  apartamentShedule: 'apartamentShedule.svg',
  handyMoving: 'handyMoving.svg',
  pickUp: 'pickUp.svg',
  sameDayPickUp: 'sameDayPickUp.svg',
  addPhoto: 'addPhoto.svg',
  trash: 'trash.svg',
  moveColored: 'moveColored.svg',
  furniture: 'furniture.png',
  rooms: 'rooms.png',
  elevator: 'elevator.png',
  sliderArrow: 'sliderArrow.svg',
  chat: 'chat.svg',
  equal: 'equal.svg',
  more: 'more.svg',
  less: 'less.svg',
  date: 'date.svg',
  interval: 'interval.svg',
  largeTruck: 'largeTruck.svg',
  time: 'time.svg',
  bigTruck: 'bigTruck.svg',
  carWash: 'carWash.svg',
  handUp: 'handup-icon.svg',
  noImgAvatar: 'no-img-avatar.svg',
  noUserAvatar: 'no-user-avatar.svg',
  pointOnMap: 'pointOnMapIcon.svg',
  callIcon: 'call-icon.svg',
  moneyIcon: 'money-icon.svg',
  carIcon: 'car-icon.svg',
  peopleIcon: 'people-icon.svg',
  alarmIcon: 'alarm-icon.svg',
  alarmIconLight: 'alarm-icon-light.svg',
  carNearbyIcon: 'car-nearby-icon.svg',
  msgIcon: 'msg-icon.svg',
  seatSliderArrowRight: 'slider-arrow-right.svg',
  timeWaitIcon: 'time-wait-icon.svg',
  checkMarkRed: 'check-mark-red.svg',
  dollarIcon: 'dollar-icon.svg',
  arrowDownFrame: 'arrow-down-frame.svg',
  arrowUpFrame: 'arrow-up-frame.svg',
  cameraIcon: 'camera-icon.svg',
  dollarMinimalistic: 'dollarMinimalistic.svg',
  logo: 'logo.svg',
  emoji_1: 'emoji_1.png',
  emoji_2: 'emoji_2.png',
  emoji_3: 'emoji_3.png',
  emoji_4: 'emoji_4.png',
  emoji_5: 'emoji_5.png',
  emoji_6: 'emoji_6.png',
  emoji_7: 'emoji_7.png',
  emoji_7_1: 'emoji_7_1.png',
  emoji_8: 'emoji_8.png',
}

export default new Proxy({}, {
  get(target, key: keyof typeof names) {
    return key in names ?
      `/assets/images/${
        SITE_CONSTANTS.ICONS_PALETTE_FOLDER &&
          `${SITE_CONSTANTS.ICONS_PALETTE_FOLDER}/`
      }${names[key]}` :
      undefined
  },
}) as typeof names